<template>
  <div class="user-list">
    <v-layout
    fluid
    column
    class="pa-0 ma-0 team-view"
    align-center
    justify-content>
      <page-title title="Users"></page-title>
      <!-- <h2>Total Users: {{ usersCount }}</h2> -->
      <v-flex class="team-table">
        
        <div class="lg-search">
          <v-text-field v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
        </div>
        
        <v-data-table :headers="headers"
              :items="users" :headers-length="headers.length"
              :pagination.sync="pagination"
              :loading="loading"
              :total-items="usersCount"
              dense
              :rows-per-page-items="rowsPerPage"
              :rows-per-page-text="rowsPerPageLabel"
              class="lg-table"
            >
          <template v-slot:items="props">
            <tr @click="selectUser(props.item)" class="user-item">
              
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.role }}</td>
              <td>{{ props.item.plan_id }}</td>
              <td>{{ props.item.plan_type }}</td>
              <td>{{ props.item.timezone }}</td>
            </tr>
          </template>
          <template v-slot:pageText="props">
            Showing {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            <div class="list-empty">
              No users found.
            </div>
          </template>
        </v-data-table>
      </v-flex>

      <SideNav
      v-model="userSideNav.model"
      @cancel="userSideNav.model = false"
      @save="saveUser"
      title="Plan Details"
      :actions="userSideNav.user.id">
        <template v-slot:body>
          <v-layout fluid column style="max-width: 250px; height: auto">
            
            <!-- <v-flex class="text-input-container">
              <label> Email </label>
              <v-text-field
                class="lg-text-field"
                v-model="userSideNav.user.email"
                solo
                v-validate="'required|email|max:50'"
                :error-messages="errors.collect('Email')"
                data-vv-name="Email"
                counter="50"
                :disabled="userSideNav.user.id ? true : false"
              ></v-text-field>
            </v-flex> -->
            <v-flex class="text-input-container">
              <label>Plan Type</label>
              <v-select
                class="lg-select role-select"
                :items="planTypeList"
                solo
                required
                v-validate="'required'"
                data-vv-name="Plan_Type"
                :error-messages="errors.collect('Plan_Type')"
                v-model="userSideNav.user.plan_type"
              ></v-select>
            </v-flex>
            <v-flex class="text-input-container">
              <label>Billing Cycle</label>
              <v-select
                class="lg-select role-select"
                :items="billingCycles"
                solo
                required
                v-validate="'required'"
                data-vv-name="Billing Cycle"
                :error-messages="errors.collect('Billing Cycle')"
                v-model="userSideNav.user.billing_cycle"
                @change="recalculatePlanList()"
              ></v-select>
            </v-flex>
            <v-flex class="text-input-container" v-show="userSideNav.user.plan_type==='NORMAL'">
              <label>Plan Name</label>
              <v-select
                class="lg-select role-select"
                :items="planList"
                solo
                required
                v-validate="'required'"
                data-vv-name="Plan"
                :error-messages="errors.collect('Plan')"
                v-model="userSideNav.user.plan_name"
                @change="recalculatePlanAmount()"
              ></v-select>
            </v-flex>
            <v-flex class="text-input-container" v-show="userSideNav.user.plan_type!=='NORMAL'">
              <label>Plan Name</label>
              <v-text-field
                class="lg-text-field"
                v-model="userSideNav.user.plan_name"
                solo
                v-validate="'required'"
                :error-messages="errors.collect('Plan_Name')"
                data-vv-name="Plan Name"
              ></v-text-field>
            </v-flex>
            <v-flex class="text-input-container">
              <label>Amount</label>
              <v-text-field
                class="lg-text-field"
                v-model="userSideNav.user.amount"
                solo
                v-validate="'required'"
                :error-messages="errors.collect('Amount')"
                data-vv-name="Amount"
                :disabled="userSideNav.user.plan_type === 'NORMAL' ? true : false"
              ></v-text-field>
            </v-flex>
            <!-- <v-btn
              color="accent"
              medium
              depressed=""
              @click="saveUser"
              :loading="userSideNav.saveLoading"
              class="submit-button"
            >
              Save
            </v-btn> -->
          </v-layout>
        </template>
      </SideNav>
    </v-layout>
    <!-- <router-view class="base"> </router-view> -->
  </div>
</template>

<script>
import adminApi from '@/admin/api/admin'
import routes from '@/admin/route_names'
import SideNav from '@/components/SideNav'
export default {
  name: 'UsersView',
  components: { SideNav},
  mounted: function() {
    this.getUsers();
    this.getUsersCount();
    this.getPlans();
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name', align: 'center', sortable: false},
        { text: 'Email', value: 'username', align: 'center', sortable: false},
        { text: 'Role', value: 'role', align: 'center', sortable: false},
        { text: 'Plan Id', value: 'plan_id', align: 'center', sortable: false},
        { text: 'Plan Type', value: 'plan_type', align: 'center', sortable: false},
        { text: 'Timezone', value: 'timezone', align: 'center', sortable: false}
      ],
      users: [],
      usersCount: 0,
      search: '',
      rowsPerPage: [10, 20, 30],
      pagination: {
        // descending: false,
        page: 1,
        rowsPerPage: 20
      },
      loading: true,
      rowsPerPageLabel: 'Limit',
      plans: {},
      planList: [],
      planTypeList: ['CUSTOM', 'NORMAL'],
      userSideNav: {
        model: false,
        user: {
          id: null,
          // plan: {},
          // plan_id: '',
          plan_name: '',
          plan_type: '',
          amount: null,
          billing_cycle: '',
          // subscription: {
          //   'plan_id': '',
          //   'plan_type': '',
          //   'amount': null,
          //   'billing_cycle': ''
          // }},
        // planList: [],
        },
        saveLoading: false
      }
    }
  },
  computed: {
    billingCycles() {
      return ['MONTHLY', 'YEARLY']
    },
    // planList() {
    //   function cycleMonthly(plan) {
    //     return plan['billing_cycle'] === 'MONTHLY';
    //   }
    //   function cycleYearly(plan) {
    //     return plan['billing_cycle'] === 'YEARLY';
    //   }

    //   var plans = this.userSideNav.user.subscription.billing_cycle == 'MONTHLY' ? this.plans['plans'].filter(cycleMonthly) : this.plans['plans'].filter(cycleYearly);
    //   console.log(plans)
    //   return plans
    //   // return this.plans['plans']
    // },
    planFeatures() {
      return this.plans['plan_features']
    }
  },
  watch: {
    pagination() {
      // this.getUsersCount();
      this.getUsers();
    },
    search() {
      this.getUsersCount();
      this.getUsers();
    }
  },
  methods: {
    recalculatePlanAmount() {
      for (var i=0; i<this.plans['plans'].length; i++) {
        var plan_id = this.userSideNav.user.plan_name.toUpperCase() + '_' + this.userSideNav.user.billing_cycle
        if (this.plans['plans'][i]['id'] === plan_id) {
          this.userSideNav.user.amount = this.plans['plans'][i]['data']['unit_price'];
          return
        }
      }
    },
    recalculatePlanList() {
      function cycleMonthly(plan) {
        return plan['billing_cycle'] === 'MONTHLY';
      }
      function cycleYearly(plan) {
        return plan['billing_cycle'] === 'YEARLY';
      }
      function getPlanId(plan) {
        return plan['name'];
      }

      this.recalculatePlanAmount();
      console.log(this.userSideNav.user);
      // console.log(this.userSideNav.user.plan);
      var planList = this.userSideNav.user.billing_cycle == 'MONTHLY' ? this.plans['plans'].filter(cycleMonthly) : this.plans['plans'].filter(cycleYearly);
      this.planList = planList.map(getPlanId);
      console.log(this.planList)
      
      // return this.planList
      // return this.plans['plans']
    },
    getPlans() {
      const vm = this;
      adminApi.getPlans()
      .then(res => {
        console.log(res);
        vm.plans = res.data.results;
      })
      .catch(err => console.log(err.data.errors))
      .finally(() => console.log(vm.plans));
    },
    getUsersCount() {
      const vm = this;
      adminApi.getUsersCount(
        {
          query: {
            phrase: vm.search.length > 0 ? vm.search : ''
          }
        }
      )
      .then(res => {
        console.log(res);
        vm.usersCount = res.data.results;
      })
      .catch(err => console.log(err.data.errors))
      .finally(() => vm.loading = false);
    },
    getUsers() {
      const vm = this;
      vm.loading = true;
      adminApi.getUsers(
        {
          query: {
            phrase: vm.search.length > 0 ? vm.search : '',
            limit: vm.pagination.rowsPerPage,
            page: vm.pagination.page
          }
        }
      )
      .then(res => {
        vm.users = res.data.results;
      })
      .catch(err => console.log(err.data.errors))
      .finally(() => vm.loading = false);
    },
    selectUser(user) {
      console.log(user)
      const vm = this;

      adminApi.getUserSubscription(user['id'])
      .then(res => {
        vm.userSideNav.model = true;
        console.log(res.data.results);
        // vm.userSideNav.user['subscription'] = res.data.results['subscription']
        vm.userSideNav.user['id'] = user['id']
        vm.userSideNav.user['plan_name'] = res.data.results['subscription']['plan']['name']
        vm.userSideNav.user['plan_type'] = res.data.results['subscription']['plan_type']
        vm.userSideNav.user['billing_cycle'] = res.data.results['subscription']['billing_cycle']
        vm.userSideNav.user['amount'] = res.data.results['subscription']['plan']['data']['unit_price'];
        // vm.userSideNav.user['plan_id'] = vm.userSideNav.user['plan_name'].toUpperCase() + '_' + vm.userSideNav.user['billing_cycle'];
        // vm.userSideNav.user['plan'] = res.data.results['subscription']['plan'];

        // this.userSideNav.user.subscription.amount = this.userSideNav.user.subscription.plan.data['unit_price']
        // delete this.userSideNav.user.subscription.plan;
      })
      .catch(err => console.log(err.data.errors))
      .finally(() => {
        this.recalculatePlanList();
        console.log(vm.userSideNav.user);
      });

      this.$nextTick(() => this.$validator.reset())
    },
    // planChanged() {
    //   this.recalculatePlanList();
    //   console.log(this.userSideNav.user.subscription.billing_cycle);
    //   console.log(this.userSideNav.user.subscription.plan);
    // },

    // billingCycleChanged(user) {
    //   function cycleMonthly(plan) {
    //     return plan['billing_cycle'] === 'MONTHLY';
    //   }
    //   function cycleYearly(plan) {
    //     return plan['billing_cycle'] === 'YEARLY';
    //   }
    //   this.plans['plans'] = user.subscription.billing_cyle == 'MONTHLY' ? this.plan['plans'].filter(cycleMonthly) : this.plan['plans'].filter(cycleYearly)
    // },
    saveUser() {
      console.log(this.userSideNav.user);
      adminApi.editUserSubscription(this.userSideNav.user)
      .then(res => {
        console.log(res.data.results);
      })
      .catch(err => console.log(err.data.errors))
      .finally(() => {
        this.userSideNav.model = false;
        this.getUsers();
      });
      
      // this.userSideNav.user.subscription.plan_id = null;
      // if (this.userSideNav.user.subscription.plan.billing_cycle !== this.userSideNav.user.subscription.billing_cycle) {
      //   this.userSideNav.user.subscription.plan = {};
      // }
      
      // if (this.userSideNav.user.id) {
      //   userApi.updateUser(u).then(function(res) {
      //     vm.userSideNav.saveLoading = false
      //     vm.userSideNav.model = false
      //     vm.getUsers()
      //   })
      // } else {
      //   userApi
      //     .addUser(u)
      //     .then(function(res) {
      //       vm.userSideNav.saveLoading = false
      //       vm.userSideNav.model = false
      //       vm.getUsers()
      //     })
      //     .catch(function(res) {
      //       res.response.data.errors.forEach(function(e) {
      //         if (e.field === 'username') {
      //           e.field = 'Email'
      //         }
      //         const field = vm.$validator.fields.find({
      //           name: e.field,
      //           scope: vm.$options.scope
      //         })
      //         if (!field) return

      //         vm.$validator.errors.add({
      //           id: field.id,
      //           field: e.field,
      //           msg: e.msg,
      //           scope: vm.$options.scope
      //         })

      //         field.setFlags({
      //           invalid: true,
      //           valid: false,
      //           validated: true
      //         })
      //       })
      //     })
      // }
    },
    // getCampaignDetails(user) {
    //   console.log(user.project_id);
    //   // this.$router.push({ name: routes.CAMPAIGNS, 
    //   //                     params: {
    //   //                       userId: user.id}
    //   //   })
    //   this.userSideNav.user = user
    //   this.userSideNav.model = true
    //   // this.currentPassword = ''
    //   // this.$nextTick(() => this.$validator.reset())
    // },
  }
}
</script>

<style lang="stylus">
.lg-search {
  width: 200px;
  margin-left: 50px;
}

.team-view {
    width 100%
    .team-header {
        text-align center
        font-size 18px
        font-weight 500
        color: $color-primary-light-1
        max-height 50px
    }
    .team-table {
        width 800px
        text-align center
        .add-user-btn {
            margin 0
        } 
    }
    .role-select  {
        .v-select__selections {
            text-align left !important
            justify-content: flex-start !important
        }
    }
    .user-item {
        cursor pointer
    }
    .submit-button {
        margin-top: 20px
    }
}
</style>
